import Modal from 'components/Modal';
import styles from '../../RouteHistory.module.scss';
import Typography from 'components/Typography';
import Ticket from './components/InboxTicket';
import {Order} from 'types';
import Button from 'components/Button';
import {useState} from 'react';

type Props = {
  inboxOrders: Order[];
  isShowModal: boolean;
  onClose: () => void;
  handleOrdersClick: (
    order: Order
  ) => (e: React.MouseEvent<HTMLDivElement>) => void;
  onAddNewDeliveries: (ids: number[], callback: () => void) => void;
  isAdding: boolean;
};
function InboxModal({
  isShowModal,
  isAdding,
  onClose,
  handleOrdersClick,
  onAddNewDeliveries,
  inboxOrders,
}: Props) {
  const [selectedOrders, setSelectedOrders] = useState<number[]>([]);

  const handleCheck = (id: number, checked: boolean) => {
    if (checked) {
      setSelectedOrders([...selectedOrders, id]);
    } else {
      setSelectedOrders(selectedOrders?.filter((item) => item !== id));
    }
  };
  const handleSubmit = () => {
    onAddNewDeliveries(selectedOrders, () => setSelectedOrders([]));
  };
  const handleClose = () => {
    setSelectedOrders([]);
    onClose();
  };
  return (
    <Modal
      isOpen={isShowModal}
      onClose={handleClose}
      onRequestClose={handleClose}
      className={styles.inboxModal}
    >
      <div className={styles.inboxModal__list_innerContainer}>
        <Typography className={styles.modalHeader}>Inbox</Typography>
        <div className={styles.list_wrapper}>
          {inboxOrders?.map((ticket, index) => (
            <Ticket
              key={index}
              index={index + 1}
              ticket={ticket}
              onChangeCheckbox={handleCheck}
              onOrdersClick={handleOrdersClick(ticket)}
              selected={selectedOrders.includes(ticket.id)}
            />
          ))}
        </div>
        {!inboxOrders.length && (
          <Typography
            textAlign="center"
            variant="p"
            className={styles.noInboxItems}
          >
            There are not any available orders.
          </Typography>
        )}
        {!!inboxOrders.length && (
          <div className={styles.actions}>
            <Button
              type="submit"
              color="blue"
              disabled={!selectedOrders.length}
              onClick={handleSubmit}
              loading={isAdding}
            >
              Add
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default InboxModal;
